export default "__VITE_ASSET__NNo1byZU__"